//importacion de firebase
import firebase from 'firebase';

const app = firebase.initializeApp({
    apiKey: "AIzaSyC438znp8gywW3xc28KmdyWv_kZx8I0HMM",
    authDomain: "scenario-79b5a.firebaseapp.com",
    databaseURL: "https://scenario-79b5a-default-rtdb.firebaseio.com",
    projectId: "scenario-79b5a",
    storageBucket: "scenario-79b5a.appspot.com",
    messagingSenderId: "456183896058",
    appId: "1:456183896058:web:87f4725737e1da16353643"
});

export default app;

